/**관할 법원 */
import styled from 'styled-components';
import CourtMap from './CourtMap';
import DisclaimerSection from '../DisclaimerSection';

// 주소 구분 함수

interface CourtInfoProps {
  court: string;
  address: string;
  belong: string;
  lat: number;
  lng: number;
}

interface Props {
  courtInfo: CourtInfoProps;
}
const JurisdictionCourt = ({ courtInfo }: Props) => {
  const handleCopyAddress = () => {
    navigator.clipboard
      .writeText(courtInfo.address)
      .then(() => {
        alert('주소가 복사되었습니다!');
      })
      .catch((err) => {
        console.error('주소 복사에 실패했습니다:', err);
        alert('주소 복사에 실패했습니다.');
      });
  };

  return (
    <DetailContainer>
      <DetailWrap>
        <TitleBox>관할법원</TitleBox>
        <CourtMap courtInfo={courtInfo} />
        <ContentWrapper>
          <CourtInfoBox>
            <CourtName>{courtInfo.court}</CourtName>
            <div>{courtInfo.belong}</div>
            {/* <div>집행관사무소: 02-1234-1234</div> */}
          </CourtInfoBox>
          <AddressBox>
            <div>{courtInfo.address}</div>
            <CopyAddress onClick={handleCopyAddress}>
              <img src="/assets/images/icon/copy-blue.svg" alt="" />
              복사
            </CopyAddress>
          </AddressBox>
        </ContentWrapper>
      </DetailWrap>
      <DisclaimerSection />
    </DetailContainer>
  );
};
export default JurisdictionCourt;

const DetailContainer = styled.div`
  width: 100%;
  height: fit-content;
  padding: 32px 16px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const TitleBox = styled.span`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1x;
  letter-spacing: -0.8px;
  width: 100%;
`;
const DetailWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  gap: 16px;
  font-family: 'Spoqa Han Sans Neo';
`;

const CopyAddress = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-wight: 500;
  font-size: 12px;
  color: #008aff;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
`;

const AddressBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-start;
  align-items: start;

  font-size: 14px;
  color: #616161;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
`;

const CourtName = styled.div`
  color: #171e26;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 23.2px;
  word-wrap: break-word;
`;

const CourtInfoBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;

  color: rgba(23, 30, 38, 0.78);
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
`;

const InnerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;
